import { useMutation } from "@tanstack/react-query";

import {
  createOnboardingPayments,
  createShopPayments,
} from "@/features/payments/api";
import { errorToast } from "@/shared/ui";

export const useCreateOnboardingPayments = () => {
  return useMutation({
    mutationFn: createOnboardingPayments,
    onError: errorToast,
  });
};

export const useCreateShopPayments = () => {
  return useMutation({
    mutationFn: createShopPayments,
    onError: errorToast,
  });
};
